import React from "react";
import { Link } from "react-router-dom";
import "./Feedback.scss";

const Feedback = () => {
    return (
        <section id="feedback" className="feedback-section">
            <h2>Feedback for Gareth Allen</h2>

            <div className="top-line"></div>
            <p className="feedback-intro">
                Please feel free to leave some feedback by contacting me {""}
                <Link to="/contact">here</Link>. Below is some very kind feedback from
                family of my service users.
            </p>
            <div className="card-wrap">
                <div className="card">
                    <i>
                        Gareths visits are the highlight of my Mums week, making her laugh,
                        keeping her active and reminding her to take her medication. We
                        would ask him to move in if he had the time! I cannot recommend his
                        service enough.
                    </i>
                    <p className="feedback-author">LH - Bradford-on-Avon</p>
                </div>
                <div className="card">
                    <i>
                        Since Gareth started visiting, Mums life is so much better. She
                        looks forward to his visits each week. Gareth takes her out in her
                        wheelchair for walks and to places she used to be able to go to
                        independently. She has a lovely time when returning home to sit and
                        chat with Gareth having a cup of tea before he leaves. His visits
                        have given her a new focus and break up what can be a very lonely
                        week. She has said that Gareth has given her the opportunity to do
                        things and go places that she thought she would never be able to do
                        again.
                    </i>
                    <p className="feedback-author">SW - Monkton Farleigh</p>
                </div>
                <div className="card">
                    <i>
                        Gareth has been befriending my husband for a couple of months now.
                        Gareth is extremely personable and very friendly. My husband always
                        looks forward to his trips out and about with Gareth and comes home
                        afterwards having had a great time. He regards him as a "smashing
                        chap and a great friend". I would highly recommend Gareth to anyone
                        who needs later life support.
                    </i>
                    <p className="feedback-author">Mrs S - Wiltshire</p>
                </div>
            </div>
        </section>
    );
};

export default Feedback;

